import z from 'zod';
import { userRoleEnum, users } from '@/db/schema';
import { passwordSchema } from '../auth/auth.schema';
import { queryParamsSchema } from '../core/schemas';

const userColumns = Object.keys(users ?? {}) as [
  keyof typeof users,
  ...(keyof typeof users)[],
];

export const userSchemas = {
  queryParams: queryParamsSchema.extend({
    orderBy: z
      .enum(
        userColumns,
        `Campo inválido! Deve ser um dos seguintes: ${userColumns.join(', ')}`,
      )
      .optional(),
    id: z.string().optional(),
    name: z.string().optional(),
    email: z.string().optional(),
    role: z.string().optional(),
    isActive: z.string().optional(),
    createdAt: z.coerce.date().optional(),
    createdAtFrom: z.coerce.date().optional(),
    createdAtTo: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
    updatedAtFrom: z.coerce.date().optional(),
    updatedAtTo: z.coerce.date().optional(),
  }),
  create: z.object({
    name: z.string('Campo obrigatório!').min(1, 'Campo obrigatório!'),
    email: z.email('E-mail inválido!'),
    password: passwordSchema,
    role: z.enum(
      userRoleEnum.enumValues,
      `Campo inválido! Deve ser um dos seguintes: ${userRoleEnum.enumValues.join(', ')}`,
    ),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional().default(true),
  }),
  update: z.object({
    name: z.any().readonly().optional(),
    email: z.any().readonly().optional(),
    role: z
      .enum(
        userRoleEnum.enumValues,
        `Campo inválido! Deve ser um dos seguintes: ${userRoleEnum.enumValues.join(', ')}`,
      )
      .optional(),
    isActive: z.boolean('Deve ser verdadeiro ou falso').optional(),
  }),
};

export type UserQueryParams = z.infer<typeof userSchemas.queryParams>;
export type CreateUserSchema = z.input<typeof userSchemas.create>;
export type UpdateUserSchema = z.infer<typeof userSchemas.update>;
